<template>
  <div class="loading-container col-12 px-0" aria-live="polite" :aria-busy="state === 'loading'">
    <loader v-if="state === 'loading'" :i18nMessage="i18nLoadingMessage" />
    <error-message v-if="state === 'error'" :i18nMessage="i18nErrorMessage" class="mt-2" />
    <link-back v-if="state === 'error' && errorLinkTo" :to="errorLinkTo" :i18nMessage="i18nErrorLinkMessage" class="mt-2" />
    <slot v-if="state === 'success'"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { LoadingState } from '@/utils/loadingUtils'
import Loader from '@/components/feedback/Loader.vue'
import ErrorMessage from '@/components/feedback/ErrorMessage.vue'
import LinkBack from '../interaction/LinkBack.vue';
import { RouteLocationRaw } from 'vue-router';

export default defineComponent({
  name: 'LoadingContainer',
  components: {
    Loader,
    ErrorMessage,
    LinkBack
  },
  props: {
    state: String as PropType<LoadingState>,
    i18nErrorMessage: {
      type: String,
      default: 'common.error.unknown'
    },
    i18nErrorLinkMessage: {
      type: String,
      default: 'common.backToOverview'
    },
    i18nLoadingMessage: {
      type: String,
      default: undefined
    },
    errorLinkTo: [String, Object] as PropType<RouteLocationRaw|string>
  }
});
</script>
<style scoped>
  .loading-container[aria-busy=true] {
    min-height: 900px;
  }
</style>
